export default Object.freeze({
  CARRIER_PAYMENT_COMPLETED: 12,
  PACKING: 3,
  CANCELLED: 2,
});
